export function debounce(func, delay, leading = false) {
    let timeout;
    let called = false; // Track if the leading call was made

    return function (...args) {
        const context = this;

        if (leading && !called) {
            func.apply(context, args);
            called = true;
        }

        clearTimeout(timeout);
        timeout = setTimeout(() => {
            if (!leading) func.apply(context, args);
            called = false; // Reset for future calls
        }, delay);
    };
}

export function getMimeType(dataUrl) {
    const mimeType = dataUrl.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+)\;base64,/);
    if (mimeType) {
        return mimeType[1];
    }
    return null;
}

export function getExtensionFromMimeType(mimeType) {
    switch (mimeType) {
        case 'image/jpeg':
            return '.jpg';
        case 'image/png':
            return '.png';
        case 'image/gif':
            return '.gif';
        case 'image/bmp':
            return '.bmp';
        case 'image/webp':
            return '.webp';
        default:
            return ''; // Unknown or unsupported MIME type
    }
}